import React from 'react';
import { Col, Row, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/pro-solid-svg-icons";
import FormField from './FormField';
import { cityItems } from '../../register/helpers/locationData';

const RegisterStep2 = ({
  localRegisterInputs,
  handleChange,
  fieldErrors,
  handleBackToStep1,
  registerClick,
  isButtonDisabled
}) => {
  // PrimeReact Dropdown expects options as [{label, value}]
  const cityOptions = cityItems.map((item) => ({ label: item.name, value: item.id }));

  return (
    <Row className="m-t-30">
      <Col lg="12">
        <Row className="align-items-center">
          <Col sm="12">
            <FontAwesomeIcon
              icon={faAngleLeft}
              className="back-icon"
              onClick={handleBackToStep1}
              style={{ cursor: 'pointer' }}
            />
          </Col>
          <Col>
            <FormField
              type="dropdown"
              id="city-dropdown"
            //   label="Şehir"
              name="city"
              value={localRegisterInputs.city?.id || ''}
              onChange={handleChange}
              placeholder="Şehir Seçiniz"
              options={cityOptions}
              hasError={!!fieldErrors.city}
              errorMessage={fieldErrors.city}
            />
          </Col>
        </Row>

        <Row>
          <FormField
            type="textarea"
            id="address"
            label="Adres"
            name="address"
            value={localRegisterInputs.address}
            onChange={(e) => handleChange("address", e.target.value)}
            placeholder="Adresinizi giriniz"
            hasError={!!fieldErrors.address}
            errorMessage={fieldErrors.address}
            rows={5}
            className="w-100"
          />
        </Row>

        <Row>
          <Row style={{ display: "inline" }} className="m-0">
            <Button
              slot="end"
              variant="dark"
              className="custom-button m-t-10 m-b-15"
              onClick={registerClick}
              disabled={isButtonDisabled(localRegisterInputs, 2)}
            >
              ONAYLA
            </Button>
          </Row>
        </Row>
      </Col>
    </Row>
  );
};

export default RegisterStep2;
